import React, { useEffect, useRef } from 'react';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { DOCUMENT_HINT } from '../documentPrefill';

function StepBeneficiario({
  register, errors, watch, setValue, isValid,
  prefilled = new Set(),
}) {
  const prefillAttempted = useRef(false);

  useEffect(() => {
    if (prefillAttempted.current) return;
    prefillAttempted.current = true;

    if (watch('gender') !== 'G' || watch('beneficiary_business_name')) return;

    const touched = { shouldDirty: true, shouldTouch: true, shouldValidate: true };
    setValue('beneficiary_business_name', watch('business_name') ?? '', touched);
    setValue('beneficiary_vat_or_fiscal_code', watch('vat_number') ?? '', touched);
  }, [watch, setValue]);

  return (
    <div data-testid="cauzioni-step-beneficiario">
      <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <h2 className="cauzioni-card-title mb-3">Beneficiario</h2>
          <p className="cauzioni-count mb-3">
            Precompilato con i dati del contraente. Modifica se il beneficiario è diverso.
          </p>

          <FormInputText
            label="Ragione sociale *"
            registration={register('beneficiary_business_name')}
            error={errors.beneficiary_business_name?.message}
            valid={isValid('beneficiary_business_name')}
            hint={prefilled.has('beneficiary_business_name') ? DOCUMENT_HINT : undefined}
          />

          <FormInputText
            label="Partita IVA / Codice Fiscale"
            registration={register('beneficiary_vat_or_fiscal_code')}
            error={errors.beneficiary_vat_or_fiscal_code?.message}
            valid={isValid('beneficiary_vat_or_fiscal_code')}
            hint={prefilled.has('beneficiary_vat_or_fiscal_code') ? DOCUMENT_HINT : undefined}
          />
        </div>
      </div>
    </div>
  );
}

export default StepBeneficiario;
